import { Button } from '@/components/ui/button';

export interface StartCallScreenProps {
  title?: string;
  subtitle?: string;
  onStart: () => void;
  disabled?: boolean;
  loading?: boolean;
}

export const StartCallScreen = ({
  title = 'Start Interview',
  subtitle = 'Get ready and press start when you are set.',
  onStart,
  disabled = false,
  loading = false,
}: StartCallScreenProps) => {
  return (
    <div className='flex h-full w-full items-center justify-center'>
      <div className='flex w-full max-w-md flex-col items-center gap-4 rounded-lg border border-border bg-background p-6 text-center shadow-sm'>
        <h2 className='text-xl font-semibold'>{title}</h2>
        <p className='text-sm text-muted-foreground'>{subtitle}</p>
        <Button size='lg' onClick={onStart} disabled={disabled}>
          {loading ? 'Loading…' : 'Start Call'}
        </Button>
      </div>
    </div>
  );
};
